"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread2"));
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _choerodonUiFont = require("choerodon-ui-font");
var _noop = _interopRequireDefault(require("lodash/noop"));
var _enum = require("../../pro/lib/form/enum");
var _enum2 = require("../../pro/lib/table/enum");
var _enum3 = require("../../pro/lib/button/enum");
var _localeContext = require("../../pro/lib/locale-context");
var _utils = require("../../pro/lib/form/utils");
var _enum4 = require("../../pro/lib/data-set/enum");
var _enum5 = require("../../pro/lib/field/enum");
var _getReactNodeText = _interopRequireDefault(require("../../pro/lib/_util/getReactNodeText"));
var _formatReactTemplate = _interopRequireDefault(require("../../pro/lib/formatter/formatReactTemplate"));
var _FeedBack = _interopRequireDefault(require("../../pro/lib/data-set/FeedBack"));
var _confirm3 = _interopRequireDefault(require("../../pro/lib/modal/confirm"));
var _enum6 = require("../../pro/lib/core/enum");
var _enum7 = require("../_util/enum");
var _enum8 = require("../trigger/enum");
var _popover = _interopRequireDefault(require("../popover"));
var _excluded = ["content", "hidden"];
var defaultTooltipTheme = function defaultTooltipTheme(target) {
  return target === 'validation' ? 'light' : 'dark';
};
var defaultRenderEmpty = function defaultRenderEmpty(componentName) {
  switch (componentName) {
    case 'Attachment':
      return (0, _localeContext.$l)('Attachment', 'no_attachments');
    case 'Table':
      return (0, _localeContext.$l)('Table', 'empty_data');
    case 'Select':
      return (0, _localeContext.$l)('Select', 'no_matching_results');
    case 'Output':
      return '';
    default:
  }
};
var defaultFormFieldHighlightRenderer = function defaultFormFieldHighlightRenderer(_ref, element) {
  var content = _ref.content,
    hidden = _ref.hidden,
    rest = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return content ? /*#__PURE__*/_react["default"].createElement(_popover["default"], (0, _extends2["default"])({}, hidden ? (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, rest), {}, {
    visible: false
  }) : rest, {
    content: content
  }), element) : element;
};
var defaultButtonProps = {
  color: _enum3.ButtonColor.primary,
  funcType: _enum3.FuncType.flat
};
var defaultSpinProps = {
  size: _enum7.Size["default"],
  wrapperClassName: ''
};
var defaultTableColumnAlign = function defaultTableColumnAlign(_column, field, record) {
  if (field) {
    switch (field.get('type', record)) {
      case _enum4.FieldType.number:
      case _enum4.FieldType.currency:
      case _enum4.FieldType.bigNumber:
        return _enum2.ColumnAlign.right;
      case _enum4.FieldType["boolean"]:
        return _enum2.ColumnAlign.center;
      default:
    }
  }
};
function getComponentKey(component) {
  switch (component) {
    case 'Tabs':
      return 'tabs';
    case 'Modal':
      return 'modal';
    default:
      return 'table';
  }
}
var defaultCustomizedSave = function defaultCustomizedSave(code, customized, component) {
  return localStorage.setItem("".concat(getComponentKey(component), ".customized.").concat(code), JSON.stringify(customized));
};
var defaultCustomizedLoad = function defaultCustomizedLoad(code, component) {
  return Promise.resolve(JSON.parse(localStorage.getItem("".concat(getComponentKey(component), ".customized.").concat(code)) || 'null'));
};
var defaultLovShowSelectedInView = function defaultLovShowSelectedInView(viewMode) {
  return viewMode === 'drawer';
};
var defaults = {
  prefixCls: 'c7n',
  proPrefixCls: 'c7n-pro',
  iconfontPrefix: 'icon',
  ripple: true,
  collapseExpandIconPosition: 'left',
  collapseTrigger: 'header',
  lovTableProps: {},
  lovModalProps: {},
  lovAutoSelectSingle: false,
  lovShowSelectedInView: defaultLovShowSelectedInView,
  labelLayout: _enum.LabelLayout.horizontal,
  labelAlign: _enum.LabelAlign.right,
  queryBar: _enum2.TableQueryBarType.normal,
  tableBorder: true,
  tableHighLightRow: true,
  tableSelectedHighLightRow: false,
  tableRowHeight: 30,
  tableDefaultRenderer: '',
  tableColumnResizable: true,
  tableColumnHideable: true,
  performanceTableColumnHideable: true,
  tableRowDraggable: false,
  tableColumnDraggable: false,
  tableHeightChangeable: true,
  performanceTableColumnDraggable: false,
  tableColumnAlign: defaultTableColumnAlign,
  tableSpinProps: defaultSpinProps,
  tableButtonProps: defaultButtonProps,
  tableCommandProps: defaultButtonProps,
  tableAlwaysShowRowBox: false,
  tableUseMouseBatchChoose: false,
  tableEditorNextKeyEnterDown: true,
  tableAutoFocus: false,
  tableKeyboard: false,
  tableFilterSearchText: 'params',
  tableAutoHeightDiff: 80,
  performanceTableAutoHeight: false,
  tableColumnDefaultWidth: 100,
  tableColumnDefaultMinWidth: 50,
  tableColumnResizeTrigger: _enum2.TableColumnResizeTriggerType.mouseDown,
  tableAggregationColumnDefaultWidth: 250,
  tableAggregationColumnDefaultMinWidth: 50,
  customizedSave: defaultCustomizedSave,
  customizedLoad: defaultCustomizedLoad,
  tableShowRemovedRow: true,
  modalSectionBorder: true,
  drawerHeaderFooterCombined: false,
  drawerSectionBorder: true,
  drawerTransitionName: 'slide-right',
  modalOkFirst: true,
  modalAutoCenter: false,
  modalKeyboard: true,
  modalMaskClosable: false,
  modalMovable: true,
  modalClosable: false,
  buttonColor: _enum3.ButtonColor["default"],
  buttonFuncType: _enum3.FuncType.raised,
  autoInsertSpaceInButton: false,
  renderEmpty: defaultRenderEmpty,
  icons: _choerodonUiFont.categories,
  dropdownMatchSelectWidth: true,
  defaultActiveFirstOption: true,
  selectReverse: true,
  selectPagingOptionContent: '···',
  selectSearchable: false,
  selectBoxSearchable: false,
  selectReserveParam: true,
  selectTrigger: [_enum8.Action.focus, _enum8.Action.click],
  useColon: false,
  excludeUseColonTagList: _utils.defaultExcludeUseColonTag,
  numberFieldNonStrictStep: false,
  showInvalidDate: true,
  highlightRenderer: defaultFormFieldHighlightRenderer,
  onPerformance: _noop["default"],
  performanceEnabled: {
    Table: false
  },
  tooltipTheme: defaultTooltipTheme,
  showValidation: _enum.ShowValidation.tooltip,
  showHelp: _enum5.ShowHelp.newLine,
  numberFieldKeyboard: true,
  colorPreset: false,
  feedback: _FeedBack["default"],
  confirm: function () {
    var _confirm2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(message) {
      return _regenerator["default"].wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return (0, _confirm3["default"])(message);
            case 2:
              _context.t0 = _context.sent;
              return _context.abrupt("return", _context.t0 !== 'cancel');
            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
    function confirm(_x) {
      return _confirm2.apply(this, arguments);
    }
    return confirm;
  }(),
  validationMessageReportFormatter: function validationMessageReportFormatter(message) {
    return (0, _getReactNodeText["default"])( /*#__PURE__*/_react["default"].createElement("span", null, message));
  },
  validationMessageFormatter: function validationMessageFormatter(message, injectOptions) {
    return message && injectOptions ? (0, _formatReactTemplate["default"])(message, injectOptions) : message;
  },
  modalResizable: false,
  tableColumnResizeTransition: true,
  fieldFocusMode: _enum6.FieldFocusMode.checked,
  formAutoFocus: false
};
var _default = defaults;
exports["default"] = _default;